import React, {Component} from 'react';
import {Button, Divider, Form, Grid, Header, Message, Segment} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {isRequired, maxLength, minLength} from 'go/components/rules/rules';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {validatePhoneNumber} from 'common/utils';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import PhoneNumberList from './phoneNumberList';
import EmailList from './emailList';
import _ from 'lodash';
import {isFemaUser} from 'common/utils';

export class Profile extends Component {
  phoneErrorMessage = 'Enter a valid phone number.';
  lastNameErrorMessage = 'Enter a value for last name.';
  firstNameErrorMessage = 'Enter a value for first name.';
  successMsg = 'Your profile has been successfully updated!';
  failureMsg = 'An error occurred while updating your profile. Please try again later.';
  validateName = (name) => {
    return isRequired()(name) && minLength(1)(name) && maxLength(100)(name);
  };
  handleFirstNameOnBlur = () => {
    this.setState({
      firstNameError: !this.validateName(this.props.profile.firstName),
    });
  };
  handleLastNameOnBlur = () => {
    this.setState({
      lastNameError: !this.validateName(this.props.profile.lastName),
    });
  };
  handlePhoneOnBlur = () => {
    let foundError = false;
    const {profile} = this.props;
    _.forEach(profile.phoneNumbers, (number) => {
      // also mutates phone records with errors...
      foundError = foundError || validatePhoneNumber(number);
    });
    this.setState({phoneError: foundError});
  };

  validateProfile = () => {
    Promise.all([
      this.handleFirstNameOnBlur(),
      this.handleLastNameOnBlur(),
      this.handlePhoneOnBlur(),
    ]).then(() => {
      if (
        !this.state.firstNameError &&
        !this.state.lastNameErrorMessage &&
        !this.state.phoneError
      ) {
        this.props.submitUpdate();
      }
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      firstNameError: false,
      lastNameError: false,
      phoneError: false,
    };
  }

  renderFemaProfile() {
    const {firstName, lastName, emailAdr} = this.props.profile;
    const name = (firstName ? firstName : '') + (lastName ? ' ' + lastName : '');

    return (
      <Segment padded>
        <Header as="h2">Personal Information</Header>
        <FemaGoTable type="static">
          <FemaGoTable.Body>
            <FemaGoTable.Row key="emailAdr">
              <FemaGoTable.TextCell width={3}>
                <label>Email </label>
              </FemaGoTable.TextCell>
              <FemaGoTable.TextCell width={13}>
                <b>{emailAdr}</b>
              </FemaGoTable.TextCell>
            </FemaGoTable.Row>
            <FemaGoTable.Row key="name">
              <FemaGoTable.TextCell width={3}>
                <label>Name </label>
              </FemaGoTable.TextCell>
              <FemaGoTable.TextCell width={13}>
                <b>{name}</b>
              </FemaGoTable.TextCell>
            </FemaGoTable.Row>
            <FemaGoTable.Row>
              <FemaGoTable.TextCell />
              <FemaGoTable.TextCell />
            </FemaGoTable.Row>
          </FemaGoTable.Body>
        </FemaGoTable>
      </Segment>
    );
  }

  renderNonFemaProfile() {
    const {toggles} = this.props;
    let loginGovIntegration = _.includes(toggles, "loginGovIntegration");
    let emails = this.props.profile.emails;
    /*
     * override this toggle and display old page if user didn't authenticate via Login.gov.
     * Authentication through Login.gov maintains a user's user_email rows (which populates
     * profile.emails) to match what Login.gov provided after their authenticaiton.  
     * If "orphaned" user (original external emailAdr==userId user) authenticates via username/password,
     * (as is possibly in lower environments while loginGovIntegration toggle is on and before we
     * "mock" login.gov authentication through username/password UI) then that user will have
     * an empty profile.emails list.  Display old profile for them.
     */
    if (loginGovIntegration && _.isEmpty(emails)) {
      loginGovIntegration = false;
    }
    return (
      <React.Fragment>
        {this.props.showToast && (
          <Message
            positive={this.props.updateSuccess}
            negative={!this.props.updateSuccess}
          >
            {this.props.updateSuccess ? this.successMsg : this.failureMsg}
          </Message>
        )}
        <Segment padded>
          <Header as="h2">Personal Information</Header>
          <Form>
            {!loginGovIntegration &&
              <>
                <Form.Field title="E-mail">
                  <Grid>
                    <Grid.Column width={3}>
                      <label>Email: </label>
                    </Grid.Column>
                    <Grid.Column width={13}>
                      <b>{this.props.profile.emailAdr}</b>
                    </Grid.Column>
                  </Grid>
                </Form.Field>
                <Divider />
              </>
            }
            <TextBoxField
              title="Required: First name"
              value={this.props.profile.firstName}
              name="firstName"
              label="First name"
              id="firstName"
              handleChange={this.props.handleChange}
              handleBlur={this.handleFirstNameOnBlur}
              displayError={this.state.firstNameError}
              errorMessages={this.firstNameErrorMessage}
            />
            <TextBoxField
              title="Required: Last name"
              name="lastName"
              id="lastName"
              value={this.props.profile.lastName}
              label="Last name"
              handleChange={this.props.handleChange}
              handleBlur={this.handleLastNameOnBlur}
              displayError={this.state.lastNameError}
              errorMessages={this.lastNameErrorMessage}
            />
            <Divider />
            {this.props.profile.phoneNumbers && (
              <PhoneNumberList
                handleChange={this.props.handleChange}
                phoneNumbers={this.props.profile.phoneNumbers}
                handlePhoneOnBlur={this.handlePhoneOnBlur}
              />
            )}
            <Divider />
            {loginGovIntegration &&
              <>
                <EmailList emails={this.props.profile.emails} notificationEmail={this.props.profile.emailAdr} handleChange={this.props.handleChange}/>
                <Divider />
              </>
            }
            <Button
              disabled={
                this.state.firstNameError ||
                this.state.lastNameError ||
                this.state.phoneError
              }
              id="updateProfile"
              name="updateProfile"
              primary
              text="Update Profile"
              onClick={this.validateProfile}
            >
              {'Update Profile'}
            </Button>
            <Link to="/">Cancel</Link>
          </Form>
        </Segment>
      </React.Fragment>
    );
  }

  render() {
    const isfema = isFemaUser(this.props.permissions);
    return !isfema ? this.renderNonFemaProfile() : this.renderFemaProfile();
  }
}

export default Profile;
